exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-flow-diagram[data-v-e7bb4874]{position:relative;width:100%;height:100%}.fts-flow-diagram .flow-diagram[data-v-e7bb4874]{height:100%;width:100%}.fts-flow-diagram .flow-diagram-fab[data-v-e7bb4874]{position:absolute;top:0;right:0;border:1px solid var(--fts-border);border-radius:10em;background-color:var(--fts-card-background)}", ""]);

// exports
